/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_Linux_DescInputs */

const en_cad_download_linux_desc = /** @type {(inputs: Cad_Download_Linux_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flatpak for x86_64. AppImage, .deb and .rpm also available`)
};

/**
* | output |
* | --- |
* | "Flatpak for x86_64. AppImage, .deb and .rpm also available" |
*
* @param {Cad_Download_Linux_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_linux_desc = /** @type {((inputs?: Cad_Download_Linux_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_Linux_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_linux_desc(inputs)
});
export { cad_download_linux_desc as "cad.download.linux_desc" }